import axios, { AxiosInstance } from 'axios'
import config from '../../config'

const client: AxiosInstance = axios.create({
  baseURL: config.EMBONOR_SERVERLESS_SIGNUP_SERVICE,
})

export default client
